import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Container from '@components/ui/Container/Container'
import Media from '@components/ui/Media/Media'
import { findRichTextLink } from '@lib/findRichTextLink'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import { FC, useRef } from 'react'
import styles from './ThreeImagesWithText.module.scss'

export type ThreeImagesWithTextProps = {
  image1?: MediaWithCropsFragment
  image2?: MediaWithCropsFragment
  image3?: MediaWithCropsFragment
  richText?: string
  reversed?: boolean
}

const ThreeImagesWithText: FC<ThreeImagesWithTextProps> = ({
  image1,
  image2,
  image3,
  richText,
  reversed,
}) => {
  const container = useRef<HTMLDivElement>(null)

  return (
    <Container>
      <div className={styles.outerContainer}>
        <div className={styles.container} ref={container}>
          <div className={`${styles.grid} ${reversed && styles.reversed}`}>
            <div className={styles.text}>
              <TrustedHtml className={styles.richText} html={richText} />
            </div>
            <Link
              link={findRichTextLink(richText)}
              className={styles.firstImage}
            >
              <div className={styles.innerImageContainer}>
                <Media mediaWithCrops={image1} mediaClassName={styles.media} />
              </div>
            </Link>
            <Link
              link={findRichTextLink(richText)}
              className={styles.secondImage}
            >
              <div className={styles.innerImageContainer}>
                <Media mediaWithCrops={image2} mediaClassName={styles.media} />
              </div>
            </Link>
            <Link
              link={findRichTextLink(richText)}
              className={styles.thirdImage}
            >
              <div className={styles.innerImageContainer}>
                <Media mediaWithCrops={image3} mediaClassName={styles.media} />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default ThreeImagesWithText
